if (!customElements.get('af-topbar-slider')) {
  customElements.define('af-topbar-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      if (this.slides.length < 2) return;
      this.index = 0;
      this.hovered = false;
      this.focused = false;
      this.editorSelected = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches || Boolean(window.Shopify?.designMode);
      this.track = this.querySelector('.af-topbar-slider__track');
      this.querySelectorAll('.af-topbar-slider__control').forEach(button => button.hidden = false);
      this.setAttribute('data-ready', '');
      this.querySelector('[data-previous]').addEventListener('click', () => this.move(-1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.move(1), options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => {
        this.focused = this.contains(event.relatedTarget);
        this.schedule();
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', event => {
        this.paused = event.matches || Boolean(window.Shopify?.designMode);
        this.schedule();
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index < 0) return;
        this.editorSelected = true;
        this.show(index);
        this.schedule();
      }, options);
      document.addEventListener('shopify:block:deselect', () => {
        this.editorSelected = false;
        this.schedule();
      }, options);
      this.schedule();
    }

    show(index) {
      const previousIndex = this.index;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-leaving', i === previousIndex && !active);
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.toggleAttribute('inert', !active);
      });
    }

    move(direction) {
      this.show(this.index + direction);
      this.schedule();
    }

    schedule() {
      clearTimeout(this.timer);
      const stopped = this.paused || this.hovered || this.focused || this.editorSelected || document.hidden;
      this.track.setAttribute('aria-live', stopped ? 'polite' : 'off');
      if (stopped) return;
      this.timer = setTimeout(() => this.move(1), Math.max(3000, Number(this.dataset.interval) || 5000));
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.controller = null;
    }
  });
}
